<template lang="pug">
.link-list
	.link-list__select-container
		select.link-list__select(:value="currentView", @input="setCurrentView($event)", aria-labl="Filter by State")
			option(value="all") All Locations
			option(v-for="(array, state) in locations", :key="state", :value="state") {{ stateNames[state] }}
	.link-list__states
		h3.h4(v-for="(array, state) in locations", :key="state", :class="{selected: currentView == state}")
			a(href, @click.prevent="setCurrentView($event, state)") {{ stateNames[state] }}
		h3.h4(:class="{selected: currentView == 'all'}")
			a(href, @click.prevent="setCurrentView($event, 'all')") All Locations
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
	name: "LinkList",
	computed: {
		...mapGetters([
			"currentView",
			"locations",
			"stateNames",
		]),
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		setCurrentView(e, value) {
			if (e.target.matches("select")) value = e.target.value;
			this.setStateValue(["currentView", value]);
			const statesContainer = document.querySelector(".states-container");
			this.$nextTick(() => {
				window.scroll({
					top: window.scrollY + statesContainer.getBoundingClientRect().top,
					left: 0,
					behavior: "smooth"
				});
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.link-list {
	margin-bottom: 2rem;
	&__select-container {
		width: 100%;
		max-width: 100%;
		display: block;
		@include mq(sm) {
			display: none;
		}
	}
	select#{&}__select {
		width: 100%;
		max-width: 100%;
		visibility: visible;
		background: $white;
		border-color: $gray;
		font-size: 1rem;
		@include mq(sm) {
			visibility: hidden;
		}
	}
	&__states {
		display: none;
		visibility: hidden;
		@include mq(sm) {
			display: block;
			visibility: visible;
			columns: 2;
		}
		@include mq(md) {
			columns: 3;
		}
		@include mq(lg) {
			columns: 4;
		}
		@include mq(xl) {
			columns: 5;
		}
		& > h3 {
			break-inside: avoid;
			& > a {
				display: block;
				break-inside: avoid;
			}
			&.selected > a {
				color: $darkGray;
				background: none;
			}
		}
	}
}

</style>